import { Environment } from '../types';

export const getLoginUrl = (env: Environment): string => {
  const extension = env === 'prod' ? '' : `${env}.`;

  return `https://login.${extension}halter.io`;
};
